import { firstAccessibleMenuPath as firstPathFromSections } from '@containers/Layout/NavMenu/index.util';
import {
  getMenuMap,
  getSettingMenuMap,
} from '@containers/Layout/NavMenu/menuMap';
import { OrgOptimizerProcesses } from '@generated/graphql';
import { useBulkRebalanceEnabled } from '@ovComponents/4-module/bulkRebalance';
import { UserContext } from '@providers/userContextProvider';
import { useContext, useMemo } from 'react';
import { useLocalization } from './useLocalization';

export const useMenuMap = () => {
  const { translateBackendString } = useLocalization();
  const {
    userContext,
    featureFlags,
    organizationFeatureFlags,
    activeOrganization,
    permissions,
    accessiblePages,
  } = useContext(UserContext);
  const bulkRebalanceEnabled = useBulkRebalanceEnabled();
  const renameOptimizerToBulkRebalance =
    activeOrganization.optimizerProcess ===
      OrgOptimizerProcesses.PortfolioOptimizerV2 && bulkRebalanceEnabled;

  const defaultSections = useMemo(
    () =>
      getMenuMap(translateBackendString, {
        featureFlags,
        organizationFeatureFlags,
        activeOrganization,
        permissions,
        accessiblePages,
        dashboards: userContext.role?.dashboards,
        homePageConfiguration: userContext.role?.homePageConfiguration,
        configurableTablePages: userContext.role?.configurableTablePages,
        renameOptimizerToBulkRebalance,
      }),
    [
      featureFlags,
      organizationFeatureFlags,
      activeOrganization,
      permissions,
      accessiblePages,
      translateBackendString,
      userContext.role?.dashboards,
      userContext.role?.homePageConfiguration,
      userContext.role?.configurableTablePages,
      renameOptimizerToBulkRebalance,
    ],
  );

  const settingsSections = useMemo(
    () =>
      getSettingMenuMap({
        featureFlags,
        organizationFeatureFlags,
        activeOrganization,
        permissions,
        accessiblePages,
      }),
    [
      featureFlags,
      organizationFeatureFlags,
      activeOrganization,
      permissions,
      accessiblePages,
    ],
  );

  const firstAccessibleMenuPath = useMemo(
    () => firstPathFromSections(defaultSections),
    [defaultSections],
  );

  return { defaultSections, settingsSections, firstAccessibleMenuPath };
};
